import { createContext } from "react";

// Create context to share parent state across all tab screens

export const ParentLayoutContext = createContext({});
